import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}
const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  centered = true,
  className = ''
}) => {
  return <div className={`mb-12 ${centered ? 'text-center' : ''} ${className}`} data-id="element-607">
      <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-montserrat" data-id="element-608">
        {title}
      </h2>
      {subtitle && <p className="text-lg text-darkGray max-w-3xl mx-auto" data-id="element-609">{subtitle}</p>}
    </div>;
};
export default SectionHeading;